;(function (angular, _) {
  'use strict'

  class VatAccountListController {
    // DI
    $rootScope
    $uibModal
    vatManager
    displayService
    ledgerService
    snackService
    vatAccountService
    // Locals
    pagination
    vatAccounts = []
    loading = false

    constructor (
      // Angular
      $rootScope,
      // Libs
      $uibModal,
      // Managers
      VatManager,
      // Services
      DisplayService, LedgerService, PaginationModel, SnackService, VatAccountService
      // Const
      // Resolved
    ) {
      this.$rootScope = $rootScope
      this.$uibModal = $uibModal
      this.vatManager = VatManager
      this.displayService = DisplayService
      this.ledgerService = LedgerService
      this.snackService = SnackService
      this.vatAccountService = VatAccountService
      this.pagination = PaginationModel.getRaw({ perPage: 5 })
    }

    $onInit () {
      this.getList()
    }

    $onDestroy () {
      // Retire le watcher $rootScope de la pagination créée par getRaw()
      this.pagination.destroy()
    }

    getList () {
      this.loading = true
      const query = this.vatManager.query(this.pagination.toQueryOptions())
      return this.vatManager.get(query).then(({ data, meta }) => {
        this.pagination.totalElements = meta.total
        this.vatAccounts = data
      }).finally(() => {
        this.loading = false
      })
    }

    editVatAccount (vat) {
      return this.vatAccountService.edit(vat).then(() => {
        this.pagination.currentPage = 0
        return this.getList()
      })
    }

    deleteVatAccount (vat) {
      return this.vatAccountService.delete(vat).then(() => {
        this.pagination.currentPage = 0
        return this.getList()
      })
    }

    createVatAccount () {
      return this.vatAccountService.create().then((account) => {
        this.newVat({ $account: account })
        this.pagination.currentPage = 0
        return this.getList()
      })
    }
  }

  VatAccountListController.$inject = [
    // Angular
    '$rootScope',
    // Libs
    '$uibModal',
    // Managers
    'VatManager',
    // Services
    'DisplayService', 'LedgerService', 'PaginationModel', 'SnackService', 'VatAccountService'
    // Const
    // Resolved
  ]

  angular.module('kilo.routes.preferences')
    .component('vatAccountList', {
      bindings: {
        newVat: '&'
      },
      templateUrl: '/app/modules/preferences/ledger/components/vat-account-list/vat-account-list.template.html',
      controller: VatAccountListController
    })
})(window.angular, window._)
